import { Icon } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { languageName } from "astrid-helpers/src/languages";

import Button from "../../ui/components/Buttons/Button";
import DropdownMenu from "../../ui/components/DropdownMenu/DropdownMenu";

import { useProfile } from "../../authentication/state/profile";

export default function HomeLanguageDropdown({ organization, language, onChange }) {
	const { t } = useTranslation();

	const user = useProfile();

	const languageOptions = user?.[`${organization?.type}s`]?.[organization.id]?.languageOptions?.map((lang) => ({
		key: lang,
		value: lang,
		text: languageName(lang),
	}));

	if (!languageOptions?.length) {
		return null;
	}

	return (
		<DropdownMenu
			direction="right"
			options={[
				{
					key: "all",
					value: null,
					text: t("all", "All"),
				},
				...languageOptions,
			]}
			defaultValue={language}
			onChange={(data, { value }) => onChange(value)}
			trigger={
				<Button basic circular size="small">
					{`${t("language", "Language")}: ${language ? languageName(language) : t("all", "All")}`}
					<Icon size="small" name="chevron down" fitted style={{ paddingLeft: 5 }} />
				</Button>
			}
			style={{ marginBottom: 20 }}
		/>
	);
}
